import React from 'react';
import { Input } from 'antd';
import SearchIcon from '@svg/search.svg?react';
import './filter-input.scss';

interface FilterInputProps {
    placeholder: string;
    value: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const FilterInput: React.FC<FilterInputProps> = ({ placeholder, value, onChange }) => {
    return (
        <div className={'filter-input-sub-container'}>
            <span className={'icon'}><SearchIcon /></span>
            <Input
                placeholder={placeholder}
                value={value}
                className={`filter-input${value.length ? ' has-value' : ''}`}
                onChange={onChange}
                allowClear
            />
        </div>
    );
};

export default FilterInput;